﻿
import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

export interface ConfirmOptions {
    title?: string;
    body?: string;
}

const defaultOptions: ConfirmOptions = {
    title: 'Confirm ?',
    body: ''
}

@Component({
    selector: 'confirm',
    templateUrl: './confirm.component.html'
})
export class ConfirmComponent {

    //#region properties

    private _options: ConfirmOptions = defaultOptions;


    //allow to merge options values
    @Input('body')
    public get options(): ConfirmOptions { return this._options; }
    public set options(value: ConfirmOptions) { this._options = Object.assign({}, defaultOptions, value); }

    //#endregion

    //#region constructor

    constructor(private modal: NgbActiveModal) {}

    //#endregion

    //#region public methods

    public commit = () => {
        this.modal.close();
    }

    public discard = () => {
        this.modal.dismiss();
    }

    //#endregion
}

